import useLocalDataStore from "@/hooks/common/useLocalDataStore";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/departurepopupM";
import {FilterTag, FilterTagWrap, TagContainer} from "@FRAMEWORK/ui/mobile/filter";
import {Area} from "@FRAMEWORK/ui/mobile/layout";
import {GoodsDetail} from "@QUERIES/prdt/goods/useGoodsDetail";
import {Accommodation, Traffic} from "@QUERIES/prdt/goods/useGoodsOption";
import {useMemo} from "react";
import {FilterType} from "../../desktop/EventListPopup/EventListPopup";
import {D_SHOW_KEYS} from "../../common/constant";
import EventListState from "./EventListState";

interface Props {
	removeAllFilters: () => void;
	removeFilter: (key: string, value: string) => void;
	goodsCd: string;
	option: {
		trafficList: Traffic[];
		accommodationList: Accommodation[];
	};
	productDetail: GoodsDetail;
	openTrafficPopup: () => void;
	openOptionPopup: () => void;
}

const goodsState = [
	{key: "isEvReserve", text: "예약가능", value: "true"},
	{key: "isEvConfirm", text: "출발확정", value: "true"},
];

const EventListFiltersComponent = ({
	removeAllFilters,
	removeFilter,
	goodsCd,
	option,
	productDetail,
	openTrafficPopup,
	openOptionPopup,
}: Props) => {
	const {getLocalData} = useLocalDataStore();
	const filters = (getLocalData("departureFilters") as FilterType[]) || [];
	// 상품 리스트 필터
	const productListFilter = useMemo(() => {
		let arr = [];
		for (const key of D_SHOW_KEYS) {
			if (key === "minPrice") {
				const minPrice = filters.find(v => v.key === "minPrice");
				if (minPrice) arr = [...arr, {key: "price", text: minPrice.text}];
			} else if (key === "maxPrice") {
				const maxPrice = filters.find(v => v.key === "maxPrice");
				const priceObject = arr.find(v => v.key === "price");
				if (priceObject && maxPrice) priceObject.text += ` ~ ${maxPrice.text}`;
			} else {
				arr = [...arr, ...filters.filter(v => v.key === key)];
			}
		}
		return arr;
	}, [filters]);

	return (
		<>
			{productListFilter?.length > 0 && (
				<TagContainer>
					<style.ResetButton type="button" onClick={removeAllFilters}>
						전체삭제
					</style.ResetButton>
					<FilterTagWrap>
						{productListFilter.map((ftr, index) => (
							<FilterTag key={`${goodsCd}${index}`}>
								{ftr.text}
								<i onClick={() => removeFilter(ftr.key, ftr.value)}>닫기</i>
							</FilterTag>
						))}
					</FilterTagWrap>
				</TagContainer>
			)}
			<Area>
				<style.FilterCheckWrap>
					{/* 예약가능, 출발확정 */}
					{goodsState.map((item, index) => (
						<EventListState key={index} state={item} index={index} productDetail={productDetail} />
					))}
					{option?.trafficList && (
						<style.FilterCheck>
							<style.FilterButton type="button" onClick={openTrafficPopup}>
								<em>교통편</em>
							</style.FilterButton>
						</style.FilterCheck>
					)}
					{productDetail.webDisplayCls === "B" && option?.accommodationList && (
						<style.FilterCheck>
							<style.FilterButton type="button" onClick={openOptionPopup}>
								<em>옵션</em>
							</style.FilterButton>
						</style.FilterCheck>
					)}
				</style.FilterCheckWrap>
			</Area>
		</>
	);
};

const EventListFilters = (props: Props) => (
	<ErrorBoundary>
		<EventListFiltersComponent {...props} />
	</ErrorBoundary>
);

export default EventListFilters;
